// This is a list of all legacy expiry options,
// in the new site we will only display: 1w, 2w, 1m, never
export const expiryOptions = {
  '1d': 60 * 60 * 24,
  '2d': 60 * 60 * 24 * 2,
  '3d': 60 * 60 * 24 * 3,
  '1w': 60 * 60 * 24 * 7,
  '2w': 60 * 60 * 24 * 14,
  '1m': 60 * 60 * 24 * 30,
  '2m': 60 * 60 * 24 * 60,
  '3m': 60 * 60 * 24 * 90,
  '6m': 60 * 60 * 24 * 180,
  '1y': 60 * 60 * 24 * 365,
  never: 0,
};

export function convertExpiry(seconds) {
  if (typeof seconds === 'string') {
    return expiryOptions[seconds];
  }

  for (const name in expiryOptions) {
    if (expiryOptions[name] === seconds) {
      return name;
    }
  }

  return false;
}
